import { gql } from '__generated__'

export const CandidatePreferencesQuery = gql(/* GraphQL */ `
    query GetCandidatePreferences($candidateId: ID) {
        candidate(id: $candidateId) {
            startDate {
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    lastName
                }
                createdByUser {
                    firstName
                    lastName
                }
                value
            }
            updatedAt
            createdAt
            locationPreferences {
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    lastName
                }
                createdByUser {
                    firstName
                    lastName
                }
                preferenceLocationId
                order
                preferenceLocation {
                    id
                    value
                    bucket
                }
            }
            sectorPreferences {
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    lastName
                }
                createdByUser {
                    firstName
                    lastName
                }
                order
                preferenceSectorId
                preferenceSector {
                    bucket
                    id
                    value
                }
            }
            industryPreferences {
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    lastName
                }
                createdByUser {
                    firstName
                    lastName
                }
                preferenceIndustryId
                preferenceIndustry {
                    id
                    value
                    bucket
                }
                order
            }
        }
        preferenceIndustries {
            id
            value
        }
        preferenceSectors {
            id
            value
        }
        preferenceLocations {
            id
            value
        }
    }
`)
